"use client"

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string }
}) {
  const digest = error?.digest ?? "xxxx"

  return (
    <html lang="en">
      <body>
        <main className="flex min-h-screen items-center justify-center bg-white px-6">
          <div className="text-center text-gray-900">
            <p className="text-base">
              The site is currently down for maintenance, and we will be back soon.
            </p>
            <p className="mt-3 text-sm text-gray-500">Digest: {digest}</p>
          </div>
        </main>
      </body>
    </html>
  )
}
